var map = {
	"./provider-logo-agile.png": 83840,
	"./provider-logo-bigBlueButton.png": 58962,
	"./provider-logo-bluejeans.png": 99218,
	"./provider-logo-chrome.png": 62403,
	"./provider-logo-customWebhook.png": 27203,
	"./provider-logo-dialpadUberconference.png": 98388,
	"./provider-logo-edge.png": 16713,
	"./provider-logo-freeConference.png": 62108,
	"./provider-logo-freshsales.png": 9253,
	"./provider-logo-goToMeeting.png": 38775,
	"./provider-logo-google.png": 89474,
	"./provider-logo-googleMeet.png": 47869,
	"./provider-logo-hubspot.png": 87401,
	"./provider-logo-jitsi.png": 96730,
	"./provider-logo-lifesize.png": 9111,
	"./provider-logo-microsoft.png": 72503,
	"./provider-logo-msteams.png": 74407,
	"./provider-logo-nimble.png": 5550,
	"./provider-logo-opera.png": 34666,
	"./provider-logo-pipedrive.png": 36102,
	"./provider-logo-salesforce.png": 19155,
	"./provider-logo-skype.png": 94660,
	"./provider-logo-slack.png": 38623,
	"./provider-logo-speechGoogle.png": 54150,
	"./provider-logo-teamleader.png": 56449,
	"./provider-logo-teams.png": 26431,
	"./provider-logo-whereby.png": 41379,
	"./provider-logo-zendesk.png": 80063,
	"./provider-logo-zoho.png": 82891,
	"./provider-logo-zohoMeeting.png": 62031,
	"./provider-logo-zoiper5.png": 26893,
	"./provider-logo-zoom.png": 28494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50824;